export var getApiSchemaUrl = function () {
    return "".concat(window.location.origin, "/api/docs");
};
// This is the URL for the Skip Sherpa Sandbox Postman Collection
export var postmanCollectionURL = "https://www.postman.com/leadsherpa/workspace/lead-sherpa-public-workspace/collection/19040794-e8f58bb6-8586-4b84-bbde-242617981e10?action=share&creator=19040794";
